import { render } from "./ModalCriarTarefa.vue?vue&type=template&id=8b25d5c8&scoped=true"
import script from "./ModalCriarTarefa.vue?vue&type=script&lang=js"
export * from "./ModalCriarTarefa.vue?vue&type=script&lang=js"

import "./ModalCriarTarefa.vue?vue&type=style&index=0&id=8b25d5c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b25d5c8"]])

export default __exports__